<script lang="ts">
  import FloatScroll from "@/components/float-scroll.svelte";
  import type { IMenuPrimary } from "@/components/nav-unit.svelte";
  import NavUnit from "@/components/nav-unit.svelte";
  import { onMount } from "svelte";

  import {
    Collapse,
    Nav,
    Navbar,
    NavbarBrand,
    NavbarToggler,
  } from "sveltestrap";

  const sitemap: IMenuPrimary[] = [
    {
      name: "반딧불이",
      link: "/bandiburri/welcome",
      children: [
        {
          name: "인사말",
          link: "/bandiburri/welcome",
        },
        {
          name: "브랜드 소개",
          link: "/bandiburri/brand",
        },
        { name: "히스토리", link: "/bandiburri/history" },
        { name: "인증 및 수상내역", link: "/bandiburri/awarded" },
      ],
    },
    {
      name: "서비스",
      link: "/service/product",
      children: [
        { name: "제품소개", link: "/service/product" },
        { name: "교육", link: "/service/consult" },
        { name: "관리시스템", link: "/service/management" },
        { name: "연구/개발", link: "/service/development" },
      ],
    },
    {
      name: "사례",
      link: "/board/list/pf_garden",
      children: [
        { name: "시설원예", link: "/board/list/pf_garden" },
        { name: "축사", link: "/board/list/pf_barn" },
        { name: "노지/관수", link: "/board/list/pf_field" },
        { name: "모형제작", link: "/board/list/pf_model" },
        { name: "기타", link: "/board/list/pf_misc" },
      ],
    },
    {
      name: "미디어",
      link: "/board/list/news",
      children: [
        { name: "소식", link: "/board/list/news" },
        { name: "영상", link: "/board/list/video" },
        { name: "언론보도", link: "/board/list/press" },
      ],
    },
    {
      name: "고객지원",
      link: "/board/list/announce",
      children: [
        { name: "공지사항", link: "/board/list/announce" },
        { name: "주로하는 질문", link: "/board/list/faq" },
        { name: "사용관련", link: "/board/list/qna" },
        { name: "정부지원사업", link: "/board/list/govbiz" },
      ],
    },
    {
      name: "문의하기",
      link: "/contact",
      children: [],
    },
  ];

  let isOpen = false;
  let vmHeaderHeight = 0;

  var before = window.location.pathname;

  function toggle_movie(mode) {
    const header = document.getElementById("header");
    const movie_shield = document.getElementById("movie-shield");
    const nav_a = document.getElementsByClassName("nav-a");
    const dropdown_item = document.getElementsByClassName("dropdown-item");
    const dropdown_menu = document.getElementsByClassName("dropdown-menu");
    const header_logo = document.getElementById("header-logo");

    const float_scroll = document.getElementById("float-scroll");
    if (mode == "movie-end") {
      header.style.background = "rgba(255, 255, 255, 0.8)";
      header_logo.src = "/images/ci/bandi.png";
      for (var i = 0; i < nav_a.length; i++) {
        nav_a[i].style.color = "rgba(0,0,0,0.84)";
      }
      for (var i = 0; i < dropdown_item.length; i++) {
        dropdown_item[i].style.color = "rgba(0,0,0,0.84)";
      }
      for (var i = 0; i < dropdown_menu.length; i++) {
        dropdown_menu[i].style.background = "rgba(255,255,255,0.84)";
      }
    } else if (mode == "movie-do") {
      header.style.background = "rgba(255, 255, 255, 0)";
      header_logo.src = "/images/ci/bandi-white.png";
      for (var i = 0; i < nav_a.length; i++) {
        nav_a[i].style.color = "rgba(255,255,255,0.84)";
      }
      for (var i = 0; i < dropdown_item.length; i++) {
        dropdown_item[i].style.color = "rgba(255,255,255,0.84)";
      }
      for (var i = 0; i < dropdown_menu.length; i++) {
        dropdown_menu[i].style.background = "rgba(0,0,0,0)";
      }
    }
  }

  function handleNavCollapseUpdate(event) {
    isOpen = event.detail.isOpen;
  }

  function refreshGeometry() {
    vmHeaderHeight = document
      .getElementById("header")
      .getBoundingClientRect().height;
  }

  onMount(() => {
    window.onload = refreshGeometry;
    window.onresize = refreshGeometry;

    var clientWidth = document.getElementById("header").clientWidth;
    console.log(clientWidth);

    if (clientWidth < 768) toggle_movie("movie-end");

    window.onscroll = () => {
      const header = document.getElementById("header");
      const movie_shield = document.getElementById("movie-shield");
      const nav_a = document.getElementsByClassName("nav-a");
      const dropdown_item = document.getElementsByClassName("dropdown-item");
      const dropdown_menu = document.getElementsByClassName("dropdown-menu");
      const header_logo = document.getElementById("header-logo");

      const float_scroll = document.getElementById("float-scroll");

      if (window.pageYOffset == 0) {
        float_scroll.style.opacity = "0";
        setTimeout(function () {
          float_scroll.style.display = "none";
        }, 300);
      } else {
        float_scroll.style.display = "block";
        setTimeout(function () {
          float_scroll.style.opacity = "1";
        }, 10);
      }

      if (window.location.pathname == "/") {
        if (window.pageYOffset > movie_shield.offsetHeight - 116) {
          // 영상 종료
          toggle_movie("movie-end");
        } else {
          toggle_movie("movie-do");
        }
      } else {
        toggle_movie("movie-end");
      }
    };
  });
</script>

<header id="header">
  <div id="header-buttons">
    <ul>
      <li>
        <a
          class="head-link narelink"
          target="_blank"
          href="https://blog.naver.com/dper2000/"
        >
          <img src="/images/common/top_1.png" alt="네이버블로그" />
        </a>
      </li>
      <li>
        <a
          class="head-link narelink"
          target="_blank"
          href="https://www.facebook.com/%EB%B0%98%EB%94%A7%EB%B6%88%EC%9D%B4-104368752227553/?ref=page_internal"
        >
          <img src="/images/common/top_2.png" alt="페이스북" />
        </a>
      </li>
      <li>
        <a
          class="head-link narelink"
          target="_blank"
          href="https://www.youtube.com/channel/UCXv6HaUZw4u0ydciriHQk-Q"
          style="margin-right: 47px;"
        >
          <img src="/images/common/top_3.png" alt="유튜브" />
        </a>
      </li>
      <li>
        <a
          class="head-link narelink"
          target="_blank"
          href="http://www.naretrends.com/"
        >
          <img src="/images/common/top_4.png" alt="나래트랜드 홈페이지" />
        </a>
      </li>
      <li>
        <a
          class="head-link narelink"
          target="_blank"
          href="http://xspark.co.kr/eng"
        >
          <img src="/images/common/top_5.png" alt="영문 홈페이지" />
        </a>
      </li>
    </ul>
  </div>

  <Navbar light expand="md" style="transition: none !important;">
    <NavbarBrand
      href="/"
      class="me-auto navbar-brand"

    >
      <img
        id="header-logo"
        src="/images/ci/bandi-white.png"
        class="head-img"
        alt="나래트랜드 CI"
      />
    </NavbarBrand>
    <NavbarToggler class="me-1" on:click={() => (isOpen = !isOpen)} />
    <div
      class="end-0"
      style="width: 80%; margin-right: calc(8% + 10px); margin-top: 1.7rem;"
    >
      <Collapse
        style="justify-content: right; padding-bottom: 20px;"
        {isOpen}
        navbar
        expand="md"
        on:update={handleNavCollapseUpdate}
      >
        <Nav navbar style="margin-left: 1rem">
          {#each sitemap as nav}
            <NavUnit item={nav} />
          {/each}
        </Nav>
      </Collapse>
    </div>
  </Navbar>
</header>

<FloatScroll />

<style lang="scss">
  header {
    background: rgba(0, 0, 0, 0);
    height: 116px;
    border-bottom: 1px solid #ddd5;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 50;
    transition: opacity 0.25s, background-color 0.25s;
  }

  .head-link img {
    width: 20px;
  }

  .head-img {
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
  }
  @media (min-width: 768px) {
    .head-img {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }

  #header-buttons {
    position: absolute;
    right: 10%;
    top: 12px;
    display: inline-block;
    z-index: 55;

    li {
      height: 30px;
      display: inline-block;
    }

    a {
      margin-right: 4px;
      color: rgba(255, 255, 255, 0.84);
    }
  }
</style>
